export default __webpack_public_path__ + "static/media/hht2_ep15_timeline_q02_a.3c3aabbb.png";